/** Valores almacenados en MongoDB / API. */
export const MEMBER_SEX_M = "M";
export const MEMBER_SEX_F = "F";

export const MEMBER_SEX_FILTER_ALL = "";
export const MEMBER_SEX_FILTER_UNSPECIFIED = "unspecified";

/** Etiqueta legible para pantalla y exportaciones. */
export function memberSexLabel(sex) {
  const s = String(sex ?? "").trim().toUpperCase();
  if (s === MEMBER_SEX_M) return "Masculino";
  if (s === MEMBER_SEX_F) return "Femenino";
  return "Sin especificar";
}

export function isValidMemberSexValue(sex) {
  const s = String(sex ?? "").trim().toUpperCase();
  return s === MEMBER_SEX_M || s === MEMBER_SEX_F;
}
